<template>
  <CreateItem
    :status="status"
    model="hair-color"
    :latest="latest"
  >
    <FormHairColorCreate v-if="status !== 'loading'" />
  </CreateItem>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FormHairColorCreate from '../../components/FormHairColorCreate/FormHairColorCreate';
import CreateItem from '../../layouts/CreateItem/CreateItem';

export default {
  name: 'HairColorCreate',
  components: {
    FormHairColorCreate,
    CreateItem
  },
  created() {
    this.RESET_ERRORS();
    this.RESET_STATUS();
  },
  methods: {
    ...mapActions('hairColor', ['RESET_ERRORS', 'RESET_STATUS']),
  },
  computed: {
    ...mapGetters('hairColor', { hairColors: 'getAll' }),
    ...mapState('hairColor', ['status']),
    latest() {
      return this.hairColors[this.hairColors.length - 1];
    }
  },
  watch: {
    $route() {
      this.RESET_ERRORS();
    }
  }
};
</script>
